




import Vue from 'vue';
import { mapState } from 'vuex';
import {
  Component, Watch,
} from 'vue-property-decorator';
import {
  KSelectFi,
} from '@kasasa/fbase-components';
import {
  AuthStore,
} from '@kasasa/fbase-components/lib';

@Component({
  components: {
    KSelectFi,
  },
  computed: mapState(['fiId', 'graphMap', 'fiSettings', 'auth']),

})
export default class DocumentGeneratorLanding extends Vue {
  auth!: AuthStore;

  @Watch('$route', { immediate: true, deep: true })
  onRouteChange() {
    if (this.auth && this.auth.sessionData && this.auth.sessionData.fkAuthLevel === 'client') {
      const clientId: number = this.auth.sessionData.fiId;
      if (this.$route.path.includes('/adg')) {
        this.$router.replace({ name: 'adgMain', params: { clientId: clientId.toString() } });
      } else if (this.$route.path.includes('/mdg')) {
        this.$router.replace({ name: 'mdgMain', params: { clientId: clientId.toString() } });
      } else if (this.$route.path.includes('/cycledates')) {
        this.$router.replace({ name: 'cycleDates', params: { clientId: clientId.toString() } });
      } else {
        this.$router.replace({ name: 'setupMain', params: { clientId: clientId.toString() } });
      }
    }
  }
}
